import cx from 'classnames';
import { useState } from 'react';

import styles from './banner-staging.module.scss';

export const BannerStaging = () => {
  const [preprodHover, setPreprodHover] = useState<boolean>(true);

  const env = import.meta.env.VITE_ENVIRONNEMENT;

  if (env !== 'prod') {
    return (
      <div
        className={cx(
          styles['preprod_bandeau'],
          preprodHover && styles['hovered']
        )}
        onClick={() => {
          setPreprodHover(!preprodHover);
        }}
      >
        <p>Vous êtes sur un environnement de préproduction</p>
      </div>
    );
  } else {
    return <></>;
  }
};

export default BannerStaging;
